export default __webpack_public_path__ + "static/media/EIN.26680de7.png";